import { focusFirst } from './ViewletTitleBarMenuBarFocusFirst.js'

export const focus = (state) => {
  return focusFirst(state)
}
